import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './ExtensionNavbar';
/* global gtag */

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function SheetsExtensionAffiliateKit(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const navigate = useNavigate();
    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";
    }, []);
    
    const initiateAffiliateSignup = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            window.open(affiliateSignupUrl, '_blank', 'noopener,noreferrer');
        }catch(err){
            console.log('error in initiateAffiliateSignup method: ', err);
            
        }
    }

    const openAffiliateKit = e => {
        try{
            navigate(`/sheets-extension-affiliate-kit`);
        }catch(err){
            console.log('error in openAffiliateKit method: ', err);
            
        }
    }

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv' style={{maxWidth: '80%'}}>
                        <div className='title'>Affiliate Kit</div>
                        <div className='contentBox' style={{alignItems: 'normal'}}>
                            <div className='content' style={{width: '90%', height: 'auto'}}>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        1. Application Details – <a href="https://drive.google.com/file/d/1eDwQ1xZHJ_z9UktIdeJd1jRRQQ0r5J6H/view?usp=sharing" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        2. Brand Logos – <a href="https://drive.google.com/drive/folders/1nJUN4U7UgcXT2i6KGVuqzlsMeJKpgIOz?usp=sharing" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        3. Application Screenshots – <a href="https://drive.google.com/drive/folders/13yl4LvPgkZKS_PdKzPGlUOMFuSFpcsAm?usp=sharing" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        4. Demo GIF – <a href="https://drive.google.com/drive/folders/1znt34qJnwh_PtMYZ2FheRRkJWDdFLjxm?usp=sharing" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        5. Demo Screen Recording – <a href="https://drive.google.com/drive/folders/1ezBRwnI4u71N0JKDUaM69X9IkzsjXfb1?usp=sharing" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                                <div className='affiliateKitSection'>
                                    <div className='akLHS'>
                                        6. Youtube Promo – <a href="https://youtu.be/8QFhjPZhh88?si=SHFM1kyUooU_tQ5N" target="_blank" rel="noopener noreferrer" class="your-button-css-class">
                                            Link
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>            
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
            {/* <div style={{position: 'sticky', bottom: '10px'}}>
                <a href={"https://affiliate.watch/affiliate/easy-image-to-text"} target="_blank" style={{display: 'inline-block', lineHeight: 0}}>
                    <img src={"https://affiliate.watch/api/affiliate-badge/2619/featured-purple-bg-white-text"} alt="Featured as a Top Affiliate Program on Affiliate.Watch" style={{height: '80px'}}/>
                </a>
            </div> */}
        </div>
    )
}

export default SheetsExtensionAffiliateKit;